export default __webpack_public_path__ + "static/4-35152726673752965f581a825adcf6ad.jpg";